import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { BaseDialog, BaseDialogProps } from '../BaseDialog/BaseDialog';
import { BaseDialogIconButton } from '../BaseDialogIconButton/BaseDialogIconButton';
import styles from './EditDialog.module.css';
export type EditDialogProps<TAnyTabName extends string> = Omit<BaseDialogProps<TAnyTabName>, 'renderButtons'> & {
  readonly opened: boolean;
  readonly onAccept: () => void;
};
export const EditDialog = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let onAccept;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      onAccept,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = onAccept;
    $[5] = remainingProps;
  } else {
    children = $[3];
    onAccept = $[4];
    remainingProps = $[5];
  }
  let t1;
  if ($[6] !== onAccept) {
    t1 = () => [<BaseDialogIconButton key="accept" iconName="check" iconType={IconType.Regular} className={styles.acceptButton} onClick={onAccept} data-testid="EditDialog.AcceptButton" />];
    $[6] = onAccept;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const renderButtons = t1;
  let t2;
  if ($[8] !== children || $[9] !== remainingProps || $[10] !== renderButtons) {
    t2 = <BaseDialog {...remainingProps} renderButtons={renderButtons}>{children}</BaseDialog>;
    $[8] = children;
    $[9] = remainingProps;
    $[10] = renderButtons;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}) as <TAnyTabName extends string>(props: EditDialogProps<TAnyTabName>) => React.JSX.Element;